"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_base_1 = require("native-base");
const UI_1 = require("./UI");
const AccountSignUp_1 = __importDefault(require("./auth/AccountSignUp"));
const LoginView_1 = __importDefault(require("./auth/LoginView"));
const WelcomePage = ({ getImage, onGo }) => {
    const buttonWidth = 96;
    return (react_1.default.createElement(native_base_1.Box, { flex: 1, pt: "70", pb: "70", bg: UI_1.backgroundSecondary },
        react_1.default.createElement(native_base_1.Center, { p: 20, m: 3 },
            react_1.default.createElement(native_base_1.Text, { color: "white", fontSize: "3xl", fontWeight: "bold", fontFamily: 'Montserrat' }, "SapporoGo"),
            react_1.default.createElement(native_base_1.Spacer, { h: 3 }),
            react_1.default.createElement(native_base_1.Image, { alt: "SapporoGuard Logo", source: getImage('badge'), size: "lg" }),
            react_1.default.createElement(native_base_1.Spacer, { h: 3 }),
            react_1.default.createElement(native_base_1.Text, { color: "white", fontSize: "md", fontWeight: "bold", fontFamily: "Montserrat" }, "For the makers ... of mistakes"),
            react_1.default.createElement(native_base_1.Box, { alignItems: "center", p: 5 },
                react_1.default.createElement(native_base_1.HStack, { flex: 1, space: 2, alignItems: "center", alignSelf: "center", justifyContent: 'center', w: buttonWidth },
                    react_1.default.createElement(AccountSignUp_1.default, null),
                    react_1.default.createElement(LoginView_1.default, null)),
                react_1.default.createElement(native_base_1.Spacer, { height: 5 }),
                react_1.default.createElement(native_base_1.Pressable, { onPress: onGo },
                    react_1.default.createElement(native_base_1.Box, { w: buttonWidth, flex: 1, borderWidth: "1", borderColor: "white", shadow: "3", bg: UI_1.backgroundPrimary, p: "5", rounded: "8" },
                        react_1.default.createElement(native_base_1.Text, { color: "white", fontWeight: "medium", fontSize: "xl", fontFamily: "Montserrat", textAlign: 'center' },
                            "Let's Go ",
                            ' > > >')))))));
};
exports.default = WelcomePage;
